export const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY;
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;

if (!GOOGLE_API_KEY || !GOOGLE_CLIENT_ID) {
  throw new Error(
    "Missing Google API key or Client ID. Please make sure you have a .env file with VITE_GOOGLE_API_KEY and VITE_GOOGLE_CLIENT_ID set."
  );
}

export const SCOPES = ["https://www.googleapis.com/auth/drive.file", "https://www.googleapis.com/auth/spreadsheets.readonly"];

export const getOAuthToken = () => {
  return new Promise((resolve, reject) => {
    const gsiScriptId = "google-identity-services-script";
    if (document.getElementById(gsiScriptId)) {
      // Script is already loaded or loading
      if (window.google && window.google.accounts && window.google.accounts.oauth2) {
        return requestToken(resolve, reject);
      }
      // else, wait for it to load
    }

    const script = document.createElement("script");
    script.id = gsiScriptId;
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    script.onload = () => requestToken(resolve, reject);
    script.onerror = () => reject(new Error("Failed to load Google Identity Services script."));
    document.body.appendChild(script);
  });
};

const requestToken = (resolve, reject) => {
  const tokenClient = window.google.accounts.oauth2.initTokenClient({
    client_id: GOOGLE_CLIENT_ID,
    scope: SCOPES.join(" "),
    callback: (tokenResponse) => {
      if (tokenResponse && tokenResponse.access_token) {
        resolve(tokenResponse.access_token);
      } else {
        reject(new Error("Failed to get OAuth token. The user may have closed the popup."));
      }
    },
  });
  tokenClient.requestAccessToken();
};